import React, {useContext} from "react";
import {WooContext} from "../WooContext";

function ProductResultCount({products}) {
    const {pagedState} = useContext(WooContext);
    const [paged] = pagedState;
    const pageResultsTotal = parseInt(paged.offset) + parseInt(paged.size);
    const total = products.data ? products.data.products.pageInfo.offsetPagination.total || 0 : 0;
    return(
        <div className="products-result-count">
            {!products.loading && <>Showing {paged.size > total ? total : paged.offset > 0 ? `${parseInt(paged.offset+1)}-${pageResultsTotal > total ? total : pageResultsTotal}` : `1-${paged.size}`} of {total} results</>}
        </div>
    )
}

export default ProductResultCount;